import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { OVERNIGHT, todayCL } from "@/lib/format";
import { Btn } from "@/components/admin/AdminUI";

const INIT = { experience: "dia_compartido", check_in: todayCL(), check_out: todayCL(), guests: 2, units: 1, status: "confirmada", total_override: "", deposit_paid: 0, admin_notes: "" };
const CUST = { nombre: "", apellido: "", telefono: "", email: "", rut: "" };

export function ManualReservation({ open, onOpenChange, onCreated }) {
  const [exps, setExps] = useState([]);
  const [extras, setExtras] = useState([]);
  const [f, setF] = useState(INIT);
  const [c, setC] = useState(CUST);
  const [sel, setSel] = useState({});
  useEffect(() => {
    if (!open) return;
    api.get("/admin/experiences").then((r) => setExps(r.data));
    api.get("/admin/extras").then((r) => setExtras(r.data.filter((x) => x.active)));
  }, [open]);
  const on = OVERNIGHT.includes(f.experience);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    const body = {
      ...f, check_out: on ? f.check_out : f.check_in, customer: c,
      total_override: f.total_override === "" ? null : Number(f.total_override),
      extras: f.experience === "cabana" ? Object.entries(sel).map(([id, qty]) => ({ id, qty })) : [],
    };
    try {
      const r = await api.post("/admin/reservations", body);
      toast.success(`Reserva ${r.data.code} creada`);
      onCreated(); onOpenChange(false); setF(INIT); setC(CUST); setSel({});
    } catch (e) { toast.error(errMsg(e)); }
  };
  const inp = (k, l, type = "text", obj = f, setter = set) => (
    <div><Label className="text-xs">{l}</Label><Input type={type} value={obj[k]} onChange={(e) => setter(k, type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} data-testid={`manual-${k}-input`} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="manual-reservation-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">Nueva reserva manual</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="sm:col-span-2"><Label className="text-xs">Experiencia</Label>
            <select value={f.experience} onChange={(e) => set("experience", e.target.value)} className="h-10 w-full rounded-md border px-3 text-sm bg-white" data-testid="manual-experience-select">
              {exps.map((e) => <option key={e.slug} value={e.slug}>{e.name}</option>)}
            </select></div>
          {inp("check_in", on ? "Entrada" : "Fecha", "date")}
          {on && inp("check_out", "Salida", "date")}
          {inp("guests", "Personas", "number")}
          {(f.experience === "carpas" || f.experience === "rodantes") && inp("units", "Espacios", "number")}
        </div>
        {f.experience === "cabana" && (
          <div className="flex flex-wrap gap-2" data-testid="manual-extras">
            {extras.map((x) => {
              const q = sel[x.id] || 0;
              return <button key={x.id} type="button" onClick={() => setSel((s) => { const n = { ...s }; if (q) delete n[x.id]; else n[x.id] = 1; return n; })}
                className={`rounded-full border px-3 py-1 text-xs ${q ? "bg-[#5E6B52] text-white" : "bg-white"}`}>{x.name}</button>;
            })}
          </div>
        )}
        <div className="grid sm:grid-cols-2 gap-3">
          {[["nombre", "Nombre *"], ["apellido", "Apellido"], ["telefono", "Teléfono *"], ["email", "Correo"], ["rut", "RUT (opcional)"]].map(([k, l]) =>
            <div key={k}>{inp(k, l, "text", c, (kk, v) => setC((p) => ({ ...p, [kk]: v })))}</div>)}
        </div>
        <div className="grid sm:grid-cols-3 gap-3">
          <div><Label className="text-xs">Estado</Label>
            <select value={f.status} onChange={(e) => set("status", e.target.value)} className="h-10 w-full rounded-md border px-3 text-sm bg-white" data-testid="manual-status-select">
              <option value="confirmada">Confirmada</option><option value="pendiente">Pendiente</option></select></div>
          {inp("total_override", "Total manual (opcional)", "number")}
          {inp("deposit_paid", "Pago recibido", "number")}
        </div>
        {inp("admin_notes", "Notas internas")}
        <Btn onClick={submit} data-testid="manual-submit-btn">Crear reserva</Btn>
      </DialogContent>
    </Dialog>
  );
}
